import React from 'react';
import { Assemble, Drill, Hammer } from '@one-thd/sui-icons';
import { Typography } from '@one-thd/sui-atomic-components';

export const MaintenanceAlert = () => {
  const iconStyles = { width: '70px', height: '70px', margin: '8px' };

  return (
    <div className="sui-px-4 md:sui-px-6 sui-my-6" data-testid="maintenance-alert">
      <span id="icon-container" className="sui-text-brand" data-testid="icon-container">
        <Assemble color="current" style={iconStyles} data-testid="icon-assemble" />
        <Hammer color="current" style={iconStyles} data-testid="icon-hammer" />
        <Drill color="current" style={iconStyles} data-testid="icon-drill" />
      </span>
      <Typography
        data-testid="maintenance-heading"
        color="brand"
        variant="h1"
        weight="display"
      >
        MAINTENANCE UNDERWAY
      </Typography>
      <Typography
        variant="body-lg"
        data-testid="maintenance-message"
      >
        Gift Card services are unavailable at this time. Please try again later.
      </Typography>
    </div>
  );
};
